import React from "react";
import { getWeeksFromNow } from "../../../../../../common-deprecated/utils";
import { CompareV2Label } from "../../../../utils/labels";

type CompareEtaPropsType = { date: string | false; etaLoading: boolean; error: boolean };

const CompareEta = (props: CompareEtaPropsType): JSX.Element | null => {
    const { date, etaLoading, error } = props;

    if (!date || error) {
        return null;
    }

    const weeksFromNow = getWeeksFromNow(
        new Date(parseInt(date.substr(0, 4)), parseInt(date.substr(4, 2)) - 1, parseInt(date.substr(6, 2))),
    );

    return (
        <>
            {etaLoading ? (
                <CompareV2Label label="loadingEta" />
            ) : weeksFromNow && weeksFromNow > 1 ? (
                <CompareV2Label label="deliveryWeeks" params={{ weeks: weeksFromNow }} />
            ) : (
                <CompareV2Label label="deliverySingleWeek" />
            )}
        </>
    );
};

export default CompareEta;
